import { Map } from 'immutable';
import { CLEAR_SCROLLED_COMPONENT, SCROLL_TO_COMPONENT } from '@instructure/quiz-common';
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Map({});
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case SCROLL_TO_COMPONENT:
      return state.set('scrolledComponentKey', action.payload).set('scrollingFocus', action.scrollingFocus);
    case CLEAR_SCROLLED_COMPONENT:
      return state.set('scrolledComponentKey', null).set('scrollingFocus', null);
    default:
      return state;
  }
});